import { hasPermissionToRoute, getFirstRouteFromPermissions } from '@/helpers/routePermissions'

const userPermissions = async (to, from, next) => {
  const permission = await hasPermissionToRoute(to.path)

  if (permission) {
    next()
  } else {
    const firstRoute = await getFirstRouteFromPermissions()
    next(firstRoute)
  }
}

export default userPermissions
